import { systemFontStack } from "../utils/AdaptiveUiThemeStyle";
/**
 * Asplan Viak client theme
 */
export const av = {
    name: "av",
    fontStack: `"Avenir Next LT Pro", ${systemFontStack}`,
    fontWeight: 400,
    headingFontWeight: 400,
    labelTextColor: "#1d3c34",
    headingTextColor: "#1d3c34",
    primary: "#48a23f",
    primaryContrast: "#ffffff",
    secondary: "#b7dc8f",
    secondaryContrast: "#1d3c34",
    tertiary: "#1d3c34",
    success: "#48a23f",
    successContrast: "#ffffff",
    warning: "#ffc358",
    danger: "#FB8500",
    dark: "#232420",
    medium: "#e0e7ce",
    light: "#f6f8f1",
    lightContrast: "#1d3c34",
    linkTextColor: "#1d3c34",
    buttonBorderWidth: 0,
    buttonPadding: "12px",
    smallButtonPadding: "6px 8px",
    largeButtonPadding: "18px 24px",
    inputShadowBlur: 0,
    inputShadowOffset: "0 0",
};
